import { FormControl } from '@angular/forms';

export function PhoneNumberValidator(c: FormControl) {
	let phone_regex = /^0([\+]?)\d+$/;

	return !c.value || phone_regex.test(c.value)
		? null
		: {
				PhoneNumberValidator: {
					valid: false,
				},
		  };
}
